module.exports = __webpack_public_path__ + "img/partner_logo4.49e4d1d6.png";